import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { Game } from '../../../Core'

import * as selectors from '../quizzes.selectors'
import * as actions from '../quizzes.actions'

import CreateQuestion from './CreateQuestion'

const mapDispatchToProps = (dispatch) => ({
  createQuestion: bindActionCreators(actions.createQuestion, dispatch),
})

const mapStateToProps = (state) => ({
  prizeCoins: selectors.getCreatePrizeCoins(state),
  isPortable: Game.selectors.isPortable(state),
  isCreatePenalized: selectors.isCreatePenalized(state),
  loading: selectors.getLoading(state),
})

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CreateQuestion))
